/**
 * Creates an inline keypair object for use when an inline key is provided for plenum operations.
 *
 * @returns An inline keypair object
 */
export function createInlineKeyPair() {
    return { inline: {} };
}
